import { render } from "./InfoIcon.vue?vue&type=template&id=aeb405b8"
import script from "./InfoIcon.vue?vue&type=script&lang=js"
export * from "./InfoIcon.vue?vue&type=script&lang=js"
script.render = render

export default script